/* ============================================================
   glow-cart-discount.js — שדה קוד-הנחה בעגלה של Glow (drawer + עמוד /cart).
   דפוס לפי cart-note.js: custom element ש-fetch(theme.routes.cartUpdate)
   עם body JSON. Vanilla, אפס ספריות, try/catch מלא, אפס שגיאות קונסול.

   מנגנון (Cart AJAX API — נתמך מ-2025):
     החלה: POST /cart/update.js {discount:'CODE'}  (מרובים: 'a,b')
     הסרה: POST /cart/update.js {discount:''}
   התגובה מחזירה cart.discount_codes = [{code, applicable}].

   ממצאי spike (2 יח' גומי · GLOW5):
   - קוד תקף → applicable:true, המחיר יורד מיד, cart_level_discount_applications
     מתמלא → ה-cart-discount-list הקיים מציג את ההנחה (לא משכפלים כאן סכום).
   - קוד לא-תקף → applicable:false + **דורס** קוד קיים → משמרים קודים תקפים
     (שולחים existing+new, ובכשל שולחים תיקון שמסיר את הקוד הרע).
   - applicable דינמי: בכמות שמפעילה הנחה אוטומטית הקוד הופך זמנית לא-תקף,
     וחוזר אוטומטית כשהתנאי מתקיים שוב → re-sync על merge; לא זורקים קוד
     שהפך זמנית ללא-תקף.

   מיקום: ה-element חי במיקום יציב (מחוץ ל-data-merge) כדי שה-input לא
   יאבד focus/value בזמן merge. לא <form> (בעמוד /cart אנחנו בתוך <form>
   של העגלה — nested-form אסור) — div + כפתור + מקש Enter (preventDefault).
   ============================================================ */
(function () {
  'use strict';

  if (customElements.get('glow-cart-discount')) return;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root : '/';
  }
  function cartUpdateUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cartUpdate)
      ? window.theme.routes.cartUpdate
      : root() + 'cart/update.js';
  }
  function cartJsUrl() {
    return root() + 'cart.js';
  }

  var STRINGS = {
    saved: 'הקוד «{code}» נשמר — לא חל בכמות הנוכחית',
    removed: 'הקוד «{code}» הוסר',
    duplicate: 'הקוד «{code}» כבר הוחל',
    invalid: 'הקוד לא תקף או אינו חל על העגלה שלך',
    empty: 'נא להזין קוד הנחה',
    error: 'אירעה שגיאה, נסי שוב'
  };

  function fmt(tpl, code) {
    return tpl.replace('{code}', code);
  }

  var FETCH_OPTS = {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
  };

  class GlowCartDiscount extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('[data-glow-dc-form]');
      this.input = this.querySelector('[data-glow-dc-input]');
      this.submitBtn = this.querySelector('[data-glow-dc-submit]');
      this.feedbackEl = this.querySelector('[data-glow-dc-feedback]');
      this.appliedWrap = this.querySelector('[data-glow-dc-applied]');
      this.busy = false;
      this.syncController = null;
      this.busyTimer = null;

      this.codes = this.readInitial();
      this.renderApplied();

      this.onSubmitClick = this.handleSubmit.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onAppliedClick = this.handleAppliedClick.bind(this);
      this.onMerge = this.handleMerge.bind(this);

      if (this.submitBtn) this.submitBtn.addEventListener('click', this.onSubmitClick);
      if (this.input) this.input.addEventListener('keydown', this.onKeydown);
      if (this.appliedWrap) this.appliedWrap.addEventListener('click', this.onAppliedClick);
      document.addEventListener('on:cart:after-merge', this.onMerge);
      document.addEventListener('on:cart-drawer:after-open', this.onMerge);
    }

    disconnectedCallback() {
      if (this.submitBtn) this.submitBtn.removeEventListener('click', this.onSubmitClick);
      if (this.input) this.input.removeEventListener('keydown', this.onKeydown);
      if (this.appliedWrap) this.appliedWrap.removeEventListener('click', this.onAppliedClick);
      document.removeEventListener('on:cart:after-merge', this.onMerge);
      document.removeEventListener('on:cart-drawer:after-open', this.onMerge);
      if (this.syncController) this.syncController.abort();
      if (this.busyTimer) clearTimeout(this.busyTimer);
    }

    /* קורא מצב התחלתי (קודים תקפים שהשרת רינדר) — בלי fetch על load */
    readInitial() {
      try {
        var tag = this.querySelector('[data-glow-dc-initial]');
        if (!tag) return [];
        var parsed = JSON.parse(tag.textContent || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    applicableCodes() {
      var out = [];
      for (var i = 0; i < this.codes.length; i += 1) {
        if (this.codes[i] && this.codes[i].applicable && this.codes[i].code) {
          out.push(this.codes[i].code);
        }
      }
      return out;
    }

    hasCode(code) {
      var target = String(code).toLowerCase();
      for (var i = 0; i < this.codes.length; i += 1) {
        if (this.codes[i] && String(this.codes[i].code).toLowerCase() === target) {
          return this.codes[i];
        }
      }
      return null;
    }

    setBusy(state) {
      this.busy = state;
      if (this.submitBtn) {
        this.submitBtn.disabled = state;
        this.submitBtn.setAttribute('aria-busy', state ? 'true' : 'false');
      }
      this.classList.toggle('is-loading', state);
    }

    setFeedback(msg, type) {
      if (!this.feedbackEl) return;
      if (!msg) {
        this.feedbackEl.hidden = true;
        this.feedbackEl.textContent = '';
        this.feedbackEl.removeAttribute('data-state');
        return;
      }
      this.feedbackEl.hidden = false;
      this.feedbackEl.setAttribute('data-state', type || 'info');
      this.feedbackEl.textContent = msg;
    }

    handleKeydown(evt) {
      if (evt.key === 'Enter' || evt.keyCode === 13) {
        evt.preventDefault();
        this.handleSubmit(evt);
      }
    }

    handleSubmit(evt) {
      if (evt) evt.preventDefault();
      if (this.busy || !this.input) return;

      var raw = this.input.value || '';
      var code = raw.trim();
      if (!code) {
        this.setFeedback(STRINGS.empty, 'info');
        this.input.focus();
        return;
      }

      var existingMatch = this.hasCode(code);
      if (existingMatch && existingMatch.applicable) {
        this.setFeedback(fmt(STRINGS.duplicate, existingMatch.code), 'info');
        this.input.value = '';
        return;
      }

      var existing = this.applicableCodes();
      var combined = existing.slice();
      var lower = code.toLowerCase();
      var already = false;
      for (var i = 0; i < combined.length; i += 1) {
        if (combined[i].toLowerCase() === lower) { already = true; break; }
      }
      if (!already) combined.push(code);

      var self = this;
      this.setBusy(true);
      this.setFeedback('', null);

      this.postDiscount(combined.join(','))
        .then(function (cart) {
          var codes = (cart && cart.discount_codes) || [];
          var entry = null;
          for (var j = 0; j < codes.length; j += 1) {
            if (String(codes[j].code).toLowerCase() === lower) { entry = codes[j]; break; }
          }

          if (entry && entry.applicable) {
            self.codes = codes;
            self.input.value = '';
            /* בהצלחה לא מציגים שורת-הודעה: הטופס נעלם והבאנר "CODE פעיל ✓"
               הוא החיווי היחיד (דרישת עילי 5.8). ההכרזה לקוראי-מסך מגיעה
               מ-appliedWrap שהוא role="status". */
            self.setFeedback('', null);
            self.renderApplied();
            self.refreshCart();
            self.releaseBusySoon();
            return null;
          }

          /* לא-תקף → מסירים את הקוד הרע ומשחזרים את הקודים התקפים בלבד */
          self.setFeedback(STRINGS.invalid, 'error');
          return self.postDiscount(existing.join(',')).then(function (restored) {
            self.codes = (restored && restored.discount_codes) || [];
            self.renderApplied();
            self.refreshCart();
            self.releaseBusySoon();
            return null;
          });
        })
        .catch(function () {
          self.setFeedback(STRINGS.error, 'error');
          self.setBusy(false);
        });
    }

    handleAppliedClick(evt) {
      var btn = evt.target.closest('[data-glow-dc-remove]');
      if (!btn || this.busy) return;
      evt.preventDefault();

      var code = btn.getAttribute('data-glow-dc-remove');
      var lower = String(code).toLowerCase();
      var remaining = this.applicableCodes().filter(function (c) {
        return c.toLowerCase() !== lower;
      });

      var self = this;
      this.setBusy(true);
      this.setFeedback('', null);

      this.postDiscount(remaining.join(','))
        .then(function (cart) {
          self.codes = (cart && cart.discount_codes) || [];
          self.setFeedback(fmt(STRINGS.removed, code), 'info');
          self.renderApplied();
          self.refreshCart();
          self.releaseBusySoon();
          return null;
        })
        .catch(function () {
          self.setFeedback(STRINGS.error, 'error');
          self.setBusy(false);
        });
    }

    /* re-sync על merge חיצוני (שינוי כמות וכו') — applicable דינמי.
       מדלגים כשאנחנו עסוקים (merge שנגרם מה-refresh שלנו — כבר סונכרן). */
    handleMerge() {
      if (this.busy) return;
      var self = this;
      if (this.syncController) this.syncController.abort();
      this.syncController = ('AbortController' in window) ? new AbortController() : null;
      var opts = this.syncController ? { signal: this.syncController.signal } : {};
      opts.headers = { Accept: 'application/json' };

      fetch(cartJsUrl(), opts)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          self.codes = cart.discount_codes || [];
          self.renderApplied();
        })
        .catch(function () { /* abort/רשת — לא חוסם */ });
    }

    postDiscount(value) {
      var opts = {
        method: FETCH_OPTS.method,
        headers: FETCH_OPTS.headers,
        body: JSON.stringify({ discount: value })
      };
      return fetch(cartUpdateUrl(), opts).then(function (r) {
        if (!r.ok) throw new Error('cart update failed: ' + r.status);
        return r.json();
      });
    }

    /* מרענן את סקשני העגלה (זהה ל-refreshCartDrawer ב-glow-cart.js) —
       cart-discount-list + הסכומים מתעדכנים נייטיבית. */
    refreshCart() {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true, cancelable: false
      }));
      if (document.querySelector('.template-cart')) {
        var cf = document.querySelector('cart-form');
        if (cf && typeof cf.refresh === 'function') cf.refresh();
      }
    }

    /* משחרר את מצב ה-busy אחרי ה-merge שגרם ה-refresh (מונע re-sync כפול) */
    releaseBusySoon() {
      var self = this;
      if (this.busyTimer) clearTimeout(this.busyTimer);
      this.busyTimer = setTimeout(function () { self.setBusy(false); }, 650);
    }

    renderApplied() {
      if (!this.appliedWrap) return;
      var frag = '';
      var hasActive = false;
      for (var i = 0; i < this.codes.length; i += 1) {
        var c = this.codes[i];
        if (!c || !c.code) continue;
        var active = !!c.applicable;
        if (active) hasActive = true;
        var safe = this.escape(c.code);
        var note = active
          ? '<span class="glow-cart-discount__chip-state">' + this.escape('פעיל')
            + ' <span class="glow-cart-discount__chip-check" aria-hidden="true">✓</span></span>'
          : '<span class="glow-cart-discount__chip-state glow-cart-discount__chip-state--muted">' + this.escape('נשמר') + '</span>';
        frag += '<div class="glow-cart-discount__chip' + (active ? '' : ' glow-cart-discount__chip--inactive') + '">'
          + '<span class="glow-cart-discount__chip-info">'
          + '<span class="glow-cart-discount__chip-code"><bdi>' + safe + '</bdi></span>'
          + note
          + '</span>'
          + '<button type="button" class="glow-cart-discount__remove" data-glow-dc-remove="' + safe + '" '
          + 'aria-label="' + this.escape('הסרת הקוד ' + c.code) + '">'
          + this.escape('הסרה')
          + '</button>'
          + '</div>';
      }
      this.appliedWrap.innerHTML = frag;
      this.appliedWrap.hidden = frag === '';
      this.syncFormVisibility(hasActive);
    }

    /* כשיש קוד-הנחה *תקף* על העגלה — מסתירים את הטופס כולו (label+input+כפתור)
       ומשאירים רק את הבאנר הירוק "CODE פעיל ✓ · הסרה". ההסרה חיה בתוך הבאנר,
       ולכן הלקוחה עדיין יכולה להסיר/להחליף קוד.
       הערות:
       - קוד ששמור אך לא-תקף כרגע ("נשמר", applicable:false — קורה כשהנחה
         אוטומטית גוברת) *אינו* מסתיר את הטופס: היא עדיין צריכה לנסות קוד אחר.
       - הנחות אוטומטיות (Volume) אינן discount_code ולכן לא מגיעות ל-codes
         כלל — הטופס נשאר גלוי, כנדרש.
       - נקרא מתוך renderApplied בלבד, כלומר מתחלף באותו frame של ה-apply/remove
         ושל ה-re-sync על merge — בלי reload. */
    syncFormVisibility(hasActive) {
      this.classList.toggle('is-applied', !!hasActive);
      if (this.container) this.container.hidden = !!hasActive;
    }

    escape(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
  }

  customElements.define('glow-cart-discount', GlowCartDiscount);
})();
